import { AdminPanel } from '../admin-panel';
import { AdminPanelBackButton } from '../admin-panel-back-button';
import { AdminPanelBody } from '../admin-panel-body';
import { AdminPanelHeader } from '../admin-panel-header';
import { AdminPanelHeading } from '../admin-panel-heading';
import { AdminPanelHeadingText } from '../admin-panel-heading-text';
import { AdminPanelHeadingTwoText } from '../admin-panel-heading-two-text';
import { AdminPanelImageUploader } from '../admin-panel-image-uploader';
import { AdminSiteSettingsPanelProps } from './admin-site-settings-panel-props';
import { Button } from '@mint/ui';
import React from 'react';
import { useAdminSiteSettingsPanelController } from './use-admin-site-settings-panel-controller';

export const AdminSiteSettingsPanel: React.FunctionComponent<
  AdminSiteSettingsPanelProps
> = (): React.ReactElement => {
  const {
    logoImageFile,
    logoImageUrl,
    onPosterImageFile,
    onOpenCodeEditorClick,
    onOpenFooterOverrideCodeEditorClick,
    onOpenHeaderOverrideCodeEditorClick,
  } = useAdminSiteSettingsPanelController();

  return (
    <AdminPanel>
      <AdminPanelHeader>
        <AdminPanelBackButton />
        <AdminPanelHeading>
          <AdminPanelHeadingText>Site Settings</AdminPanelHeadingText>
        </AdminPanelHeading>
      </AdminPanelHeader>
      <AdminPanelBody>
        <AdminPanelHeadingTwoText>Website Logo</AdminPanelHeadingTwoText>
        <AdminPanelImageUploader
          onFile={onPosterImageFile}
          file={logoImageFile}
          url={logoImageUrl}
        />
        <div style={{ marginTop: '1rem' }}>
          <Button variant="raised" onClick={onOpenCodeEditorClick}>
            Edit Global Site HTML
          </Button>
        </div>
        <div style={{ marginTop: '1rem' }}>
          <Button
            variant="raised"
            onClick={onOpenHeaderOverrideCodeEditorClick}
          >
            Edit Header Override HTML
          </Button>
        </div>
        <div style={{ marginTop: '1rem' }}>
          <Button
            variant="raised"
            onClick={onOpenFooterOverrideCodeEditorClick}
          >
            Edit Footer Override HTML
          </Button>
        </div>
      </AdminPanelBody>
    </AdminPanel>
  );
};
